import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FacebookLoginProvider, SocialAuthService } from 'angularx-social-login';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { LoginService } from './login.service';
import { ModalRequestEmailComponent } from './modal-request-email/modal-request-email.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  role: string;
  loginForm: FormGroup;
  errorMsg: string = null;
  consentModalDialog;
  typeDeviceLogin: string;
  passwordType: boolean;
  redirect: string;

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private cookieService: CookieService,
    private socialService: SocialAuthService,
    private deviceService: DeviceDetectorService,
    private route: ActivatedRoute,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      password: ['', Validators.required]
    })

    this.redirect = window.history.state.redirect;
    this.typeDeviceLogin = 'web'
    this.gobalFunctionService.setSEO('เข้าสู่ระบบ Life Di', 'website', '');

    // this.typeDeviceLogin = this.deviceService.getDeviceInfo().deviceType;
    // // console.log(this.deviceService.getDeviceInfo().deviceType);
    // // console.log(this.typeDeviceLogin);

    // if (this.deviceService.getDeviceInfo().deviceType === 'desktop') {
    //   this.typeDeviceLogin = 'web'
    // }

  }

  loginWithFb() {
    let body;

    this.socialService.signIn(FacebookLoginProvider.PROVIDER_ID)
      .then(fb => {
        // // console.log(fb);
        body = {
          EMAIL: fb.email,
          // EMAIL: '',
          PASSWORD: '',
          TYPE_LOGIN: 'fb',
          TYPE_DEVICE_LOGIN: this.typeDeviceLogin,
          TOKEN_NOTI: '',
          DEVICE_ID: '',
          FB_ID: fb.id,
          APPLE_ID: ''
        }

        return this.loginService.checkFBIDInSystem(fb.id).pipe(
          switchMap(res => {
            // // console.log(res);
            // มีข้อมูลในระบบ
            if (res.result.Insystem) {
              body.EMAIL = res.result.EMAIL;
              return this.loginService.login(body).pipe(
                map(res => {
                  if (res.success === true) {
                    // // console.log(this.redirect);
                    this.cookieService.set('token', res.result.access_token, 7, '/');
                    window.open(this.redirect ? this.redirect : '/', '_self');
                  }
                }),
              )

              // ไม่มีข้อมูลในระบบ
            } else {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.id = `modalConsent-${Math.round(new Date().getTime() / 1000)}`;
              dialogConfig.width = "550px"
              dialogConfig.data = {
                name: "consent",
                title: "การยินยอม",
                description: `
                <h5 class="mt-2"><b>นโยบายความเป็นส่วนตัว</b></h5>
                <div class="text-left">
                -	โครงการในเว็บไซต์นี้เป็นโครงการวิจัย ไม่ใช่ การรักษาตามปกติ <br>
                -	การเข้าร่วมการวิจัยนี้ขึ้นอยู่กับความสมัครใจ ท่านสามารถตัดสินใจได้อย่างอิสระว่าจะเข้าร่วมหรือไม่เข้าร่วมการวิจัยนี้ ท่านไม่จำเป็นจะต้องเข้าร่วมในโครงการวิจัยนี้ <br>
                -	นักวิจัยผู้ขอความยินยอมต้องให้ ข้อมูลและเวลาที่เพียงพอ ในการตัดสินใจอย่างอิสระ ก่อนที่ท่านจะเข้าร่วมโครงการวิจัย <br>
                -	ท่านสามารถซักถามข้อสงสัยเกี่ยวกับโครงการวิจัยได้ ซึ่งผู้วิจัยจะอธิบายเพิ่มเติมแก่ท่านและตอบข้อซักถามจนท่านเข้าใจ <br>
                -	หากท่านสมัครใจเข้าร่วมการวิจัยนี้แล้ว ท่านยังคงสามารถถอนตัวออกจากการวิจัยได้ทุกเมื่อ โดยจะไม่มีผลกระทบต่อคุณภาพการบริการหรือการรักษาพยาบาลที่ท่านพึงได้รับตามสิทธิ</div>`,
                actionBtnText: "ยินยอม",
                cancleBtnText: "ยกเลิก"
              }
              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed().pipe(
                switchMap(res2 => {
                  if (res2) {
                    if (!body.EMAIL) {
                      // login fb ผ่านเบอร์โทรศัพท์
                      const dialogConfig2 = new MatDialogConfig();
                      dialogConfig2.disableClose = true;
                      dialogConfig2.width = "550px"

                      let addEmailDialog = this.matDialog.open(ModalRequestEmailComponent, dialogConfig2);
                      return addEmailDialog.afterClosed().pipe(
                        switchMap(res => {
                          body.EMAIL = res.email;
                          // // console.log(body);
                          return this.loginService.login(body).pipe(
                            map(res => {
                              if (res.success === true) {
                                // // console.log(this.redirect);
                                this.cookieService.set('token', res.result.access_token, 7, '/');
                                window.open(this.redirect ? this.redirect : '/', '_self');
                              }
                            })
                          )
                        })
                      )
                    } else {
                      // login fb ผ่าน email
                      return this.loginService.login(body).pipe(
                        map(res => {
                          if (res.success === true) {
                            // // console.log(this.redirect);
                            this.cookieService.set('token', res.result.access_token, 7, '/');
                            window.open(this.redirect ? this.redirect : '/', '_self');
                          }
                        })
                      )
                    }
                  } else {
                    return of(null)
                  }
                })
              )
            }
          }),
          catchError((err) => {
            // console.log(err);
            alert(err.error.message)
            return of(null);
          }),
        ).subscribe()
      });
  }

  get checkEmail() {
    return this.loginForm.get('email');
  }

  login() {
    const body = {
      EMAIL: this.loginForm.get('email').value,
      PASSWORD: this.loginForm.get('password').value,
      TYPE_LOGIN: 'system',
      TYPE_DEVICE_LOGIN: this.typeDeviceLogin,
      TOKEN_NOTI: '',
      DEVICE_ID: '',
      FB_ID: '',
      APPLE_ID: ''
    }
    this.loginService.login(body).subscribe(res => {
      if (res.success) {
        this.cookieService.set('token', res.result.access_token, 7, '/');
        this.role = res.result.role;
        window.open(this.redirect ? this.redirect : '/', '_self');
      }
    }, err => {
      this.errorMsg = err.error.message;
    });
  }

  toggle() {
    this.passwordType = !this.passwordType;
  }
}
